import PropTypes from 'prop-types'

import { SVGWrapper } from '../../../components'
import { IpmArrowRight } from '../../../assets/icons'
import { ReactComponent as HeyNicIcon } from '../../../assets/icons/HeyNicIconOnly.svg'
import { stepChatDefaults } from './stepChatDefaults'
import { CommentCard, CommentText } from './styled'

/*
 * Mobile entry point: the chatbot's opening comment for this step, shown at the
 * top of the step content. Tapping it opens the full chat overlay.
 *
 * The design pairs this with a floating action button above the footer; that half
 * is deliberately not built yet because it would collide with SBSA's
 * scroll-to-bottom button (per the story).
 */
const AdviceHeyNicComment = ({ onOpen }) => {
  const { comment } = stepChatDefaults()

  return (
    <CommentCard type='button' onClick={onOpen} aria-label={`Hey Nic: ${comment}`}>
      <HeyNicIcon />
      <CommentText>{comment}</CommentText>
      {/* Signals that the card opens the chat rather than just stating something. */}
      <SVGWrapper className='comment-chevron' svg={IpmArrowRight} size='mediumLarge' />
    </CommentCard>
  )
}

AdviceHeyNicComment.propTypes = {
  onOpen: PropTypes.func.isRequired,
}

export default AdviceHeyNicComment
